import { loader } from 'graphql.macro'

export default async function rescheduleTicket ({ dataLoaders, variables }) {
  const schema = loader('./rescheduleTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      ticketId: variables.ticketId,
      date: variables.date
    }
  })
  return response.rescheduleTicket
}
